/**
 * Driver working categories — single source of truth for the frontend.
 *
 * Sub-classifications applied when a driver's status is WORKING. The `value`
 * is the literal string stored on driverstatus.workingcategory; `label` is
 * what's shown in the UI (sometimes different, e.g. "Live Dispatch" displays
 * as "Do Not Preplan").
 *
 * To add a new category: append to WORKING_CATEGORIES below. Keep this in sync
 * with backend/app/core/constants.py.
 */

export const WORKING_CATEGORY_GROUNDED_YARD = 'Grounded Yard';
export const WORKING_CATEGORY_LIVE_DISPATCH = 'Live Dispatch';
export const WORKING_CATEGORY_IN_ROUTE_OTR = 'In Route OTR';
/** Worked today, taking no more work — dropped from smart dispatch / preplan pools. */
export const WORKING_CATEGORY_DONE_FOR_DAY = 'Done For The Day';

export interface WorkingCategoryOption {
  value: string;
  label: string;
}

export const WORKING_CATEGORIES: readonly WorkingCategoryOption[] = [
  { value: WORKING_CATEGORY_GROUNDED_YARD, label: 'Grounded Yard' },
  { value: WORKING_CATEGORY_LIVE_DISPATCH, label: 'Do Not Preplan' },
  { value: WORKING_CATEGORY_IN_ROUTE_OTR, label: 'In Route OTR' },
  { value: WORKING_CATEGORY_DONE_FOR_DAY, label: 'Done For The Day' },
];

// Map of stored value -> display label, for rendering categories pulled from API
const LABEL_BY_VALUE: Record<string, string> = WORKING_CATEGORIES.reduce(
  (acc, c) => ({ ...acc, [c.value]: c.label }),
  {}
);

/** Get the display label for a stored working-category value. Falls back to
 *  the raw value if unrecognized (e.g. legacy data). */
export function getWorkingCategoryLabel(value: string | null | undefined): string {
  if (!value) return '';
  return LABEL_BY_VALUE[value] ?? value;
}
